import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'colorestado',
    standalone: false
})
export class ColorEstado implements PipeTransform {

  transform(estado: boolean): string {

    if (!estado){
     return 'red';
    }
    else{
      return '';
    }
    // if (estado === 'RES'){
    //   return 'yellow';
    // }
    // if (estado === 'SUS'){
    //   return 'blue';
    // }
    // if (estado === 'DIS'){
    //   return 'green';
    // }
    // if (estado === 'ALQ'){
    //   return 'red';
    // }
    // if (estado === 'CURSO'){
    //   return 'green';
    // }
    // if (estado === 'VENCIDO'){
    //   return 'red';
    // }
    // if (estado === 'PROXVEN'){
    //   return 'yellow';
    // }  
    // return null;
  }

}
